import {
  ADD_LINE, AddLine,
  CartAction, REMOVE_LINE, RemoveLine, UPDATE_LINE, UpdateLine
} from '../cart.actions';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';
import { ICartLine } from '../../models/cart/i-cart-line';
import { ICart } from '../../models/cart/i-cart';
import { calcDiscountAmount } from '@cakeiteasy/web-utils';

const createHandler = (state: ICartLine[], payload: ICartLine, { appliedDiscount }: ICart) => {
  const discountValue = payload.discount ? payload.discount.value : appliedDiscount ? appliedDiscount.value : 0;
  const discountAmount = calcDiscountAmount(payload.price, discountValue);
  return [...state, { ...payload, discountAmount }];
};

const updateHandler = (state: ICartLine[] = [], payload: ICartLine, cart: ICart): any[] => {
  const index = findIndex(state, (item) => item.clientId === payload.clientId);

  if (index !== -1) {
    return state.map((item, itemIndex) => {
      return itemIndex === index
        ? cloneDeep(payload)
        : item;
    });
  }

  return createHandler(state, payload, cart);
};

const deleteHandler = (state: ICartLine[], clientId: string) => {
  return state.slice().filter((item) => {
    return item.clientId && item.clientId !== clientId;
  });
};

export function linesReducer(
  state: ICartLine[] = [],
  action: CartAction,
  cart: ICart
) {
  switch (action.type) {
    case ADD_LINE:
      return createHandler(state, (action as AddLine).line, cart);
    case REMOVE_LINE:
      return deleteHandler(state, (action as RemoveLine).clientId);
    case UPDATE_LINE:
      return updateHandler(state, (action as UpdateLine).line, cart);
    default: {
      return state;
    }
  }
}
